import { render, staticRenderFns } from "./CognitiveKXYH.vue?vue&type=template&id=531b6b88&scoped=true"
import script from "./CognitiveKXYH.vue?vue&type=script&lang=js"
export * from "./CognitiveKXYH.vue?vue&type=script&lang=js"
import style0 from "./CognitiveKXYH.vue?vue&type=style&index=0&id=531b6b88&prod&scoped=true&lang=css"
import style1 from "./CognitiveKXYH.vue?vue&type=style&index=1&id=531b6b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b6b88",
  null
  
)

export default component.exports